import { Temporal } from '@js-temporal/polyfill'

import type { Template } from '../types'

/**
 * Returns a template with the 'New' tag added if:
 * - Template was created within the last 7 days
 * - Template is not part of a campaign
 * - Template doesn't already have the 'New' tag
 *
 * Otherwise returns the template unchanged.
 */
export const withNewTagIfRecent = (
  template: Template,
  currentTime: Temporal.ZonedDateTime,
): Template => {
  const isRecent =
    Temporal.PlainDate.compare(
      Temporal.PlainDate.from(template.createdAt.slice(0, 10)),
      currentTime.toPlainDate().subtract({ days: 7 }),
    ) > 0

  if (
    isRecent &&
    (!template.linkedCampaigns || template.linkedCampaigns.length === 0) &&
    !template.tags.includes('New')
  ) {
    return { ...template, tags: [...template.tags, 'New' as const] }
  }

  return template
}
